import styled from '@mui/system/styled';
import { Box } from '@mui/material';

export const ArrowsContainer = styled('div')({
  background: '#616161',
  borderRadius: '3px',
  height: 16,
  width: 20,
  alignItems: 'center',
  justifyContent: 'center',
  display: 'flex',
  svg: { width: 12, height: 12 },
});

export const ImageContainer = styled(Box)({
  position: 'relative',
  padding: '24px',
  height: 'fit-content',
  '.slick-prev': {
    left: 16,
  },
  '.slick-next': {
    right: 16,
  },
  '.slick-prev, .slick-next': {
    zIndex: 1,
    borderRadius: '50%',
    width: 42,
    height: 42,
    background: 'white',
  },
  '.slick-prev:hover, .slick-prev:focus, .slick-next:hover, .slick-next:focus':
    {
      background: 'white',
    },
  '.slick-prev:before, .slick-next:before': {
    color: 'black',
    fontFamily: 'Manrope',
    fontSize: 27,
  },
  '.slick-prev:before': {
    content: '"\\2039"',
  },
  '.slick-next:before': {
    content: '"\\203A"',
  },
  '.slick-slide': {
    height: 550,
  },
});

export const HeaderContent = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: '20px',
  height: 42,
});

export const ButtonsContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: 12,
  height: 42,
  button: {
    color: '#212121',
    height: 42,
    width: 42,
    background: '#EEEEEE',
    '&:hover': {
      background: '#e5e5e5',
    },
  },
});

export const ImageBox = styled('div')({
  justifyContent: 'center',
  display: 'flex !important',
  background: 'lightgray',
  borderRadius: 16,
  overflow: 'hidden',
  img: {
    width: 'auto',
    height: 550,
    transition: 'transform 0.3s ease-in-out',
    borderRadius: 8,
  },
});
